'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _class;

var _reduxAsyncConnect = require('redux-async-connect');

var _reactRedux = require('react-redux');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRouterRedux = require('react-router-redux');

var _catalog = require('redux/actions/catalog');

var _modal_type = require('redux/actions/modal_type');

var _sliders = require('redux/actions/sliders');

var _sliders2 = require('redux/constants/sliders');

var _constants = require('redux/constants');

var _helpers = require('helpers');

var _LocalStorageProxy = require('ibonus/LocalStorageProxy');

var _LocalStorageProxy2 = _interopRequireDefault(_LocalStorageProxy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    Main: {
        displayName: 'Main'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/containers/Main/Main.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var Main = _wrapComponent('Main')((_dec = (0, _reduxAsyncConnect.asyncConnect)([
// {promise: ({store: {dispatch, getState}}) => {
//     return dispatch(refreshCatalog());
// }},
{ promise: function promise(_ref) {
        var _ref$store = _ref.store,
            dispatch = _ref$store.dispatch,
            getState = _ref$store.getState;

        if (getState().setting.slider_novelty) {
            return dispatch((0, _sliders.getProductForSlider)(_sliders2.SLIDER_NEW));
        }return null;
    } }, { promise: function promise(_ref2) {
        var _ref2$store = _ref2.store,
            dispatch = _ref2$store.dispatch,
            getState = _ref2$store.getState;

        if (getState().setting.slider_hits) {
            return dispatch((0, _sliders.getProductForSlider)(_sliders2.SLIDER_HIT));
        }return null;
    } }, { promise: function promise(_ref3) {
        var _ref3$store = _ref3.store,
            dispatch = _ref3$store.dispatch,
            getState = _ref3$store.getState;

        if (getState().setting.slider_popular) {
            return dispatch((0, _sliders.getProductForSlider)(_sliders2.SLIDER_POPULAR));
        }return null;
    } }]
// {promise: ({location, store: {dispatch, getState}}) => {
//         let id = getState().setting.rootCategory.id || 0,
//             limit = parseInt(location.query.limit, 10) || CatalogNumericConstants.CATEGORY_PAGE_LIMIT,
//             page = parseInt(location.query.page, 10) || 1;
//
//         if (limit > CatalogNumericConstants.MAX_LIMIT) {
//             limit = CatalogNumericConstants.CATEGORY_PAGE_LIMIT;
//         }
//         if (page > CatalogNumericConstants.MAX_PAGE) {
//             page = 1;
//         }
//
//         return dispatch(getByCategory({id, page: --page, limit}));
// }}
), _dec2 = (0, _reactRedux.connect)(function (state) {
    return {
        setting: state.setting,
        sliders: state.sliders,
        catalog: state.catalog,
        user: state.auth.user,
        lang: state.lang
    };
}, {
    push: _reactRouterRedux.push,
    getProductForSlider: _sliders.getProductForSlider,
    showModalAuth: _modal_type.showModalAuth
}), _dec(_class = _dec2(_class = function (_Component) {
    (0, _inherits3.default)(Main, _Component);

    function Main() {
        var _ref4;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, Main);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref4 = Main.__proto__ || (0, _getPrototypeOf2.default)(Main)).call.apply(_ref4, [this].concat(args))), _this), _this.updateProducts = function () {
            var result = [];
            if (_this.props.setting.slider_novelty) {
                result.push(_this.props.getProductForSlider(_sliders2.SLIDER_NEW));
            }
            if (_this.props.setting.slider_hits) {
                result.push(_this.props.getProductForSlider(_sliders2.SLIDER_HIT));
            }
            if (_this.props.setting.slider_popular) {
                result.push(_this.props.getProductForSlider(_sliders2.SLIDER_POPULAR));
            }
            return result;
        }, _this.handleChangePage = function (page, limit) {
            _this.props.push('/?limit=' + limit + '&page=' + page);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(Main, [{
        key: 'render',
        value: function render() {
            var _props$setting = this.props.setting,
                slider_novelty = _props$setting.slider_novelty,
                slider_hits = _props$setting.slider_hits,
                slider_popular = _props$setting.slider_popular,
                orderInOneClick = _props$setting.orderInOneClick,
                buyInCreditActive = _props$setting.buyInCreditActive,
                buyInCredit = _props$setting.buyInCredit;
            var _props$catalog = this.props.catalog,
                activePage = _props$catalog.activePage,
                categories = _props$catalog.categories,
                categoryPreload = _props$catalog.categoryPreload,
                count = _props$catalog.count,
                limit = _props$catalog.limit,
                products = _props$catalog.products;
            var _props = this.props,
                setting = _props.setting,
                sliders = _props.sliders,
                lang = _props.lang;

            var View = _helpers.ThemeHelper.getViewForContainer('Main');

            var sliderSettings = {
                slider_novelty: slider_novelty,
                slider_hits: slider_hits,
                slider_popular: slider_popular,
                orderInOneClick: orderInOneClick,
                buyInCreditActive: buyInCreditActive,
                buyInCredit: buyInCredit
            };

            var title = setting.seoTitle || lang['menu.main'];
            var redirectAuthBefore = _LocalStorageProxy2.default.getItem('redirect_before_auth');

            if (!this.props.user && redirectAuthBefore) {
                this.props.showModalAuth(lang);
            } else if (redirectAuthBefore) {
                _LocalStorageProxy2.default.removeItem('redirect_before_auth');
                this.props.push(redirectAuthBefore);
            }
            return _react3.default.createElement(
                'div',
                { className: 'col-xs-12 no-margin' },
                _react3.default.createElement(_reactHelmet2.default, { title: title }),
                _react3.default.createElement(View, {
                    activePage: activePage,
                    categories: categories,
                    count: count,
                    limit: limit,
                    products: products,
                    sliders: sliders,
                    sliderSettings: sliderSettings,
                    preload: categoryPreload,
                    settings: setting,
                    handleChangePage: this.handleChangePage,
                    updateProducts: this.updateProducts,
                    lang: lang
                })
            );
        }
    }]);
    return Main;
}(_react2.Component)) || _class) || _class));

exports.default = Main;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Main/Main.jsx
// module id = 1811
// module chunks = 0